import React, { Component } from "react";
import { firebaseApp } from "../firebase/firebase";
import AccountCircle from "material-ui/svg-icons/action/account-circle"
import AppBar from "material-ui/AppBar";
import IconButton from "material-ui/IconButton";
import IconMenu from "material-ui/IconMenu";
import ActionHome from 'material-ui/svg-icons/action/home';
import Pages from 'material-ui/svg-icons/social/pages';
import MenuItem from "material-ui/MenuItem";
import Notifications from "material-ui/svg-icons/social/notifications";
import Timer from "material-ui/svg-icons/image/timer";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as authActions from "../components/auth/auth_actions";
import * as commonActions from './common_actions';
import { ToolbarGroup } from "material-ui/Toolbar";

class TopNavbar extends Component {
  constructor() {
    super();
    this.state = { showDocSearch: false, showMessages: false };
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    this.props.fetchNotifications();
  }

  handleLogout = () => {
    this.props.logoutUser();
  };

  handleClearNotifications = () => {
    this.props.clearNotifications(this.props.user.uid);
  }

  render() {
    return (
      <div>
        <AppBar
          elevation={0}
          showMenuIconButton={false}
          title={
            <img
              src={require("../assets/mozak.png")}
              style={{ width: 150, marginBottom: 10, marginLeft: 50 }}
              alt={"Logo"}
            />
          }
          style={{ height: 55, position: 'fixed', boxShadow: 'none !important', backgroundColor: '#013243'}}
        >
          <ToolbarGroup style={{ marginRight: 0 }}>
            <p
              style={{
                marginTop: 15,
                fontSize: 14,
                marginRight: 5,
                color: "#ffffff",
                fontWeight: 300
              }}
            >
              {this.props.user.email}
            </p>

            <IconButton touch={true} iconStyle={{ color: "#59ABE3" }} containerElement={<Link to="" />}>
              <ActionHome />
            </IconButton>

            <IconButton touch={true} iconStyle={{ color: "#59ABE3" }} containerElement={<Link to="/marketing" />}>
              <Pages />
            </IconButton>

            <IconMenu
              iconButtonElement={
                <IconButton touch={true} iconStyle={this.props.notifications.length < 1? { color: "#59ABE3" }:{ color: "#F5D76E" }}>
                  <Notifications />
                </IconButton>
              }
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              targetOrigin={{ horizontal: "right", vertical: "top" }}
              menuStyle={{ width: 350 }}
            >
              <MenuItem primaryText={'Mark as read'} onClick={this.handleClearNotifications}/>
              {
                this.props.notifications.map((notification, i) => {
                  console.log(notification)
                  return (
                    <MenuItem
                      key={i}
                      leftIcon={<Notifications />}
                      primaryText={`New Notification: ${notification.message}`}
                      style={{ fontSize: 12 }}
                    />
                  )
                })
              }
            </IconMenu>

            <IconButton touch={true} iconStyle={{ color: "#59ABE3" }} containerElement={<Link to="/timetracker" />}>
              <Timer />
            </IconButton>

            <IconMenu
            iconButtonElement={
              <IconButton touch={true} iconStyle={{ color: "#59ABE3" }}>
                <AccountCircle />
              </IconButton>
            }
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            targetOrigin={{ horizontal: "left", vertical: "top" }}
            > 
            <MenuItem
              primaryText="Profile"
              containerElement={<Link to="/profile" />}
            />
            <MenuItem
              primaryText="Logout"
              onClick={this.handleLogout}
            />
          </IconMenu>

          </ToolbarGroup>
        </AppBar>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user } = state.auth;
  const { navOpen, notifications, smallWindow } = state.common;
  return { user, navOpen, notifications, smallWindow };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchNotifications: () => dispatch(commonActions.fetchNotifications()),
    clearNotifications: (uid) => dispatch(commonActions.clearNotifications(uid)),
    logoutUser: () => dispatch(authActions.logoutUser()),
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(TopNavbar);



// WEBPACK FOOTER //
// ./src/common/navbar.js